__turbopack_context__.v({
  "container": "Header-module-scss-module__wS1-Va__container",
  "logo": "Header-module-scss-module__wS1-Va__logo",
  "navWrapper": "Header-module-scss-module__wS1-Va__navWrapper",
  "root": "Header-module-scss-module__wS1-Va__root",
  "toolbar": "Header-module-scss-module__wS1-Va__toolbar",
});
